module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE3IDE3Ij4KICAgIDxwYXRoIGZpbGw9IiM0RkE0NDQiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTUuMDY2IDEzLjUzNWExLjEwMiAxLjEwMiAwIDAgMS0uMTAyLjA3N2wtMy4yNjMgMi4yMDFhMS4wOSAxLjA5IDAgMSAxLTEuMjItMS44MDhsMy4yNTUtMi4xOTZhNi42NTggNi42NTggMCAxIDEgMS4zMyAxLjcyNXptMy42ODItLjQ4MWE0LjQ3NyA0LjQ3NyAwIDEgMCAxLjcwOC04Ljc4OSA0LjQ3NyA0LjQ3NyAwIDAgMC0xLjcwOCA4Ljc4OXoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-search.svg
// module id = 416
// module chunks = 0